import React from "react";

const Settings = ({closeSettings}) => {
  return (
    <div className="settings">
      <h1 style={{fontSize: '50px', textAlign: 'center', paddingTop: '50px'}}>Coming soon...</h1>
      <div className="btn" onClick={closeSettings}>close</div>
    </div>
  );
};

export default Settings;
